import type { IAudienceHeartbeatAggregate } from '@lucimark/shared/models/playback-heartbeat'

/** Latest aggregate to attach to the next playback-heartbeat (one-shot per heartbeat). */
let pending: IAudienceHeartbeatAggregate | null = null

let onPendingChange: ((value: IAudienceHeartbeatAggregate | null) => void) | undefined

/** Wire Vue / UI to pending aggregate changes (queue, take). Pass `undefined` to detach. */
export function setAudienceAggregatePendingListener(
  cb: ((value: IAudienceHeartbeatAggregate | null) => void) | undefined
): void {
  onPendingChange = cb
}

/** Called by on-device audience pipeline when a new interval aggregate is ready. */
export function queueAudienceHeartbeatAggregate(aggregate: IAudienceHeartbeatAggregate): void {
  pending = aggregate
  onPendingChange?.(aggregate)
}

/** Inspect pending aggregate without consuming (for gating before take). */
export function peekAudienceHeartbeatAggregatePending(): IAudienceHeartbeatAggregate | null {
  return pending
}

/** Returns and clears the pending aggregate for the current heartbeat send. */
export function takeAudienceHeartbeatAggregateForNextHeartbeat(): IAudienceHeartbeatAggregate | undefined {
  if (pending == null) {
    return undefined
  }
  const out = pending
  pending = null
  onPendingChange?.(null)
  return out
}
